import {AppThunk} from '../../index';
import {PollResponsePayload} from '../../../../shared/models/api';
import {httpService, HttpWrapperOptions} from '../../../../shared/httpWrapper';
import {getApiRoute} from '../../../../shared/pipes/getApiRoute';
import {apiUrls} from '../../../../shared/constants/urls';
import {pollsListSlice} from '../../../reducers/polls/list';

const setPollsList = pollsListSlice.actions.setPolls;

export const getPollsList = (): AppThunk => {
  return async (dispatch) => {
    const route = getApiRoute(apiUrls.getPolls);
    const options = new HttpWrapperOptions().TrackRequest();
    const response = await httpService.get<PollResponsePayload[]>(route, options);
    dispatch(setPollsList(response));
  };
};
